import ApiClient from '@/api/ApiClient';

const client = new ApiClient('organizationfusionrequest');

class OrganizationFusionRequestApi {

	static add (addOrganizationFusionRequestModel: IAddOrganizationFusionRequestModel) {
		return client.post(``, addOrganizationFusionRequestModel);
	}

	static grid (pagedListParameters: IOrganizationFusionRequestPagedListParameters) {
		return client.post<IPagedList<IOrganizationFusionRequestModel>>(`grid`, pagedListParameters);
	}

	static detail (id:number) {
		return client.get<IOrganizationFusionRequestDetailModel>(id.toString());
	}

	static countWithoutResponse () {
		return client.get<number>('countwithoutresponse');
	}

	static update (id: number, updateOrganizationFusionRequestModel: IUpdateOrganizationFusionRequestModel) {
		return client.put(id.toString(), updateOrganizationFusionRequestModel);
	}
}

export default OrganizationFusionRequestApi;
